import React, { Component } from 'react';
import { Waypoint } from "react-waypoint";

import tinycolor from 'tinycolor2';
import * as d3 from 'd3';

import VillagerAvatar from '../components/VillagerAvatar';
import Button from '../components/Button';
import Dialogue from '../components/Dialogue';

import ChartSpecs from '../data/chart_specs';


const colorWheelObj = ChartSpecs.chartspecs.colorWheelObjRainbow;
const colorWheelObjBrightness = ChartSpecs.chartspecs.colorWheelObjBrightness;
var colorWheelArray = Object.keys(colorWheelObj);
var colorRange = Object.values(colorWheelObj);
const brightnessColorArray = Object.keys(colorWheelObjBrightness);
const brightnessColorRange = Object.values(colorWheelObjBrightness);
var margin = ChartSpecs.chartspecs.margin;


class VillagerAppearanceSkincolor extends Component {
  constructor(props){
      super(props);
      this.svgRef = React.createRef();

      this.allVillagers = this.props.villagers;
      this.tierNodes = {};
      // is SkinColor Warm or Cold
      this.allVillagers.forEach((villager) => {
        let skinColor = tinycolor(this.props.villagerSkinColors.get(villager.id))
        villager.skinColorHsl = skinColor.toHsl();
        villager.colorSegment = this.colorSegment(villager.skinColorHsl.h);
      });
   }

   componentDidMount() {
     this.svg = d3.select(this.svgRef.current);

     this.tierNodes = d3.groups(this.allVillagers, d => d.tier, d => d.colorSegment);
     this.tierNodes2 = d3.rollup(this.allVillagers, v => v.length, d => d.tier, d => d.colorSegment);
     this.tierArray = [...this.tierNodes2.keys()];
     //this.drawSkinColorChart();
     this.drawAreaStackChartH();
   }


    sortColorsByHue(colors) {
      return colors.sort(function (a, b) {
          return a.skinColorHsl - b.skinColorHsl;
      });
    }

    colorSegment(hue){
      let is6Segment = true;
      let numberOfSegment = is6Segment? 6:12;
      let startDegree = 0;
      let endDegree = 360;
      let base = 360/numberOfSegment;
      let halfBase = base/2;
      if(is6Segment){
        if(hue >= startDegree && hue < halfBase || hue > endDegree - halfBase && hue <= endDegree){
          // hue >= 0 && hue < 30 || hue > 330 && hue < 360
          return "red"
        }else if (hue >= halfBase && hue < halfBase + base*1){
          // hue >= 30 && && hue < 90
          return "yellow"
        }else if (hue >= halfBase + base*1 && hue < halfBase + base*2){
          // hue >= 90 && && hue < 150
          return "green"
        }else if (hue >= halfBase + base*2 && hue < halfBase + base*3){
          // hue >= 150 && && hue < 210
          return "cyan"
        }else if (hue >= halfBase + base*3 && hue < halfBase + base*4){
          // hue >= 210 && && hue < 270
          return "blue"
        }else if (hue >= halfBase + base*4 && hue < halfBase + base*5){
          // hue >= 270 && && hue < 360
          return "magenta"
        }
      }else{
        if(hue >= startDegree && hue < halfBase || hue > endDegree - halfBase && hue <= endDegree){
          // hue >= 0 && hue < 15 || hue > 345 && hue < 360
          return "red"
        }else if (hue >= halfBase && hue < halfBase + base*1){
          // hue >= 15 && && hue < 45
          return "orange"
        }else if (hue >= halfBase + base*1 && hue < halfBase + base*2){
          // hue >= 45 && && hue < 75
          return "yellow"
        }else if (hue >= halfBase + base*2 && hue < halfBase + base*3){
          // hue >= 75 && && hue < 105
          return "yellowgreen"
        }else if (hue >= halfBase + base*3 && hue < halfBase + base*4){
          // hue >= 105 && && hue < 135
          return "green"
        }else if (hue >= halfBase + base*4 && hue < halfBase + base*5){
          // hue >= 135 && && hue < 165
          return "turquoise"
        }else if (hue >= halfBase + base*5 && hue < halfBase + base*6){
          // hue >= 165 && && hue < 195
          return "cyan"
        }else if (hue >= halfBase + base*6 && hue < halfBase + base*7){
          // hue >= 195 && && hue < 225
          return "ocean"
        }else if (hue >= halfBase + base*7 && hue < halfBase + base*8){
          // hue >= 225 && && hue < 255
          return "blue"
        }else if (hue >= halfBase + base*8 && hue < halfBase + base*9){
          // hue >= 255 && && hue < 285
          return "violet"
        }else if (hue >= halfBase + base*9 && hue < halfBase + base*10){
          // hue >= 285 && && hue < 315
          return "magenta"
        }else if (hue >= halfBase + base*10 && hue < halfBase + base*11){
          // hue >= 315 && && hue < 345
          return "raspberry"
        }
      }

    }

    drawAreaStackChartH(){
         var svg = this.svg,
             chartWidth = this.svgRef.current.clientWidth,
             chartHeight = 430,
             stackKeys = colorWheelArray,
             radius = 40;


         let tierNodes = this.tierNodes,
              tierNodes2 = this.tierNodes2,
              tierArray = this.tierArray;

         let tableData = Array.from(tierNodes2.entries())
         .map(g => {
           const obj = {};
           obj["tier"] = g[0];
           for (let col of stackKeys) {
             const vals = g[1].get(col);
             //console.log("vals: "+vals);
             obj[col] = !vals ? 0 : vals;
           }
           return obj;
         })
        .sort((a, b) => a["tier"] - b["tier"]);


         const xScale = d3.scaleBand()
               .domain(tierArray)
               .range([margin.left, chartWidth + margin.right])
               .paddingOuter(0.25)

              // .padding(0.25)

         const yScale= d3.scaleLinear()
                       .range([chartHeight - margin.top, margin.top])
                       // .range([ chartHeight/totalBarGroups - margin.top, margin.top/totalBarGroups])


         const colorScale = d3.scaleOrdinal()
                     .domain(colorWheelArray)
                     .range(colorRange)

         const yAxis = g => g
                     .attr("transform", `translate(${margin.left},0)`)
                     .call(d3.axisLeft(yScale).ticks(chartWidth / 100, "%"))
                     .call(g => g.selectAll(".domain").remove());

         const xAxis = g => g
                   .attr("transform", `translate(${-margin.left/2},${ chartHeight - margin.top/1.5})`)
                    //.attr("transform", `translate(0,${margin.top+10})`)
                   .call(d3.axisBottom(xScale).tickFormat(function(d,i){ return `T.${d}` }).tickSizeOuter(0))
                   .call(g => g.selectAll(".domain").remove())



                 const formatPercent = d3.format(".1%");
                 const formatValue = x => isNaN(x) ? "N/A" : x.toLocaleString("en")

                   // Creating the clone of the array
                   let clonetableData = tableData.slice(0);

                   const clonetableDataArr = tableData.map(d => ({ ...d}));

                   // Extract the array using splice method
                   let tableDataExtended = clonetableDataArr.splice(0,tierArray.length);

                   const clonetableDataFirst = tableDataExtended[0];
                   const clonetableDataLast = tableDataExtended[tierArray.length-1];

                   //let tableDataExtended = tableData.slice();

                   tableDataExtended.unshift(clonetableDataFirst);
                   tableDataExtended.push(clonetableDataLast);

                   let newFirst = tableDataExtended[0],
                       newLast = tableDataExtended[tableDataExtended.length-1];


                 const series = d3.stack()
                               .keys(stackKeys)
                               .offset(d3.stackOffsetExpand)
                             (tableDataExtended)
                               .map(d => (d.forEach(v => v.key = d.key), d))

         svg.attr("id", 'skincolorChart');
         svg.attr("height", chartHeight);

         svg.append("g")
         .attr("class", 'xaxis tier-axis')
         .call(xAxis);

         svg.append("g")
         .attr("class", 'yaxis')
         .call(yAxis);

         // define the area
         let area = d3.area()
             .y0(d => yScale(d[0]))
             .y1(d => yScale(d[1]))
             .x((d,i) => {
               if(i === 0){
                 return xScale.bandwidth()/2 + margin.left/2
               }else if(i === (tableDataExtended.length-1)){
                 return  xScale(d.data.tier) + xScale.bandwidth()/2
               }else{
                 return  xScale(d.data.tier)
               }
             })
             //.y0(yScale(0))
             //.y(d => yScale(d.data.tier))
             .curve(d3.curveBasis)


        let layer = svg.append("g")
              .selectAll(".layer")
              .data(series)
             .join("g")
              .attr("class", "layer")
              .attr("transform", `translate(${0}, ${0})`);

        layer.append("path")
              .attr("class", "area-skincolor")
              .attr("fill", d => colorScale(d.key))
              .attr("d", area);


         // define the area
         let area2 = d3.area()
             .x(d => xScale(d.data.tier))
             .y0(d => yScale(d[0]))
             .y1(d => yScale(d[1]))
             .curve(d3.curveBasis)


    }

    drawSkinColorChart(){
      var svg = this.svg,
          chartWidth = this.svgRef.current.clientWidth,
          chartHeight = 430,
          stackKeys = colorWheelArray,
          radius = 40,
          skinColors =  this.props.villagerSkinColors,
          textColors =  this.props.villagerTextColors,
          tooltip = d3.select('#tooltip-skinColor');


      let allVillagers = this.allVillagers;

     /* COLOR NODES SORT */
     //let tierNodes = d3.group(allVillagers, d => d.tier);
     let tierNodes = d3.groups(allVillagers, d => d.tier, d => d.colorSegment);
     let tierNodes2 = d3.rollup(allVillagers, v => v.length, d => d.tier, d => d.colorSegment);
     let tierArray = [...tierNodes2.keys()];

      let tableData = Array.from(tierNodes2.entries())
      .map(g => {
        const obj = {};
        obj["tier"] = g[0];
        for (let col of stackKeys) {
          const vals = g[1].get(col);
          //console.log("vals: "+vals);
          obj[col] = !vals ? 0 : vals;
        }
        return obj;
      })
     .sort((a, b) => a["tier"] - b["tier"]);


      chartHeight = tierNodes.length * radius + margin.top + margin.bottom

      const yScale = d3.scaleBand()
            //.domain(tierNodes.map(d => d[0])) //tiers
            .domain(tierArray)
            .range([margin.top, chartHeight - margin.bottom])
            .padding(0.25)

      const xScale= d3.scaleLinear()
                    .range([margin.left, chartWidth - margin.right])


      const colorScale = d3.scaleOrdinal()
                  .domain(colorWheelArray)
                  .range(colorRange)
                  .unknown("#ccc")

      const xAxis = g => g
                  .attr("transform", `translate(0,${margin.top + 10})`)
                  .call(d3.axisTop(xScale).ticks(chartWidth / 100, "%"))
                  .call(g => g.selectAll(".domain").remove());

      const yAxis = g => g
                .attr("transform", `translate(${margin.left},0)`)
                .call(d3.axisLeft(yScale).tickFormat(function(d,i){ return `T.${d}` }).tickSizeOuter(0))
                .call(g => g.selectAll(".domain").remove())

      const formatPercent = d3.format(".1%");
      const formatValue = x => isNaN(x) ? "N/A" : x.toLocaleString("en")
      /* set up mutiple colli  */
      let basePerRow = 10,
          baseRowWidth = (chartWidth + 0) / (basePerRow + 1);

      const series = d3.stack()
                    .keys(stackKeys)
                    .offset(d3.stackOffsetExpand)
                  (tableData)
                    .map(d => (d.forEach(v => v.key = d.key), d))


      svg.attr("height", chartHeight);
      svg.attr("id", 'skincolorchart');

      svg.append("g")
      .attr("class", 'xaxis')
      .call(xAxis);

      svg.append("g")
      .attr("class", 'yaxis tier-axis no-tick')
      .call(yAxis);

      svg.append("g")
        .selectAll("g")
        .data(series)
        .join("g")
        .attr("fill", d => colorScale(d.key))
        .selectAll("rect")
        .data(d => d)
        .join("rect")
        .attr("x", d => xScale(d[0]))
        .attr("y", (d, i) => yScale(d.data.tier))
        .attr("width", d => xScale(d[1]) - xScale(d[0]))
        .attr("height", yScale.bandwidth())
        .on("mouseenter", function(e,d) {
          const x = xScale(d[0]) + (xScale(d[1]) - xScale(d[0])) / 2;
          const y = yScale(d.data.tier);

          let thisBar = d3.select(this);


          d3.select('#tooltip-skincolor')
                      .transition()
                      .duration(200)
                      .style("display", "block");

          d3.select('#tooltip-skincolor')
            .html(
              `<p> Tier ${d.data.tier} ${d.key} ${formatPercent(d[1] - d[0])} (${formatValue(d.data[d.key])}) </p>`
            ).style(
                  "transform",
                  `translate(` + `calc( -50% + ${x}px),` + `calc(-100% + ${y}px)` + `)`
                );

           d3.select(this).transition()
                  .duration(350)
                  .style("stroke", d => colorScale(d.key))

        })
        .on('mouseleave', function() {
          d3.select('#tooltip-skincolor')
            .transition()
            .duration(200)
            .style("display", "none")

          d3.select(this)
            .transition()
            .style("stroke", 'none')


        })

         //.append("title")
         //.text(d => `Tier ${d.data.tier} ${d.key} ${formatPercent(d[1] - d[0])} (${formatValue(d.data[d.key])})`);

    }

  render() {

    let chartKeyList = colorWheelArray.map(list => {
         return (
           <li key={list}><span style={{backgroundColor: colorWheelObj[list]}}></span>{list}</li>
         )
     })

    return (
      <div ref={this.props.innerRef}  id={`villager-${this.props.step}`} className="step category-appearance">
        <h2 className="title">Skin colors</h2>
        <p className="paragraph">For a slightly more objective take on appearance, we analyzed the villagers’ skin colors to see if certain colored villagers tended to rank higher in popularity. We took the Hex color code for each villager’s skin color and grouped them into 6 color buckets:
 </p>

        <ul className={`chart-key-list ${chartKeyList.length>3?'long-list':''}`}>
          {chartKeyList}
        </ul>
        <div className="svg-wrapper">
          <div id="tooltip-skincolor" className="bar-tooltip"></div>
          <svg ref={this.svgRef} width="100%"></svg>
        </div>
        <p className="paragraph">By design, there are more villagers who have a warm skin color tone, such as red and yellow. There aren’t many strong trends, but there may be more red colored villagers in the higher tiers, and slightly more yellow or green villagers in the lower tiers.</p>

        <Dialogue title="Summary" type="regular">
          <p className="paragraph">There isn't a strong relationship between skin color and villager popularity, but green villagers may be slightly less popular.</p>
        </Dialogue>

      </div>
    )
  }
}

export default VillagerAppearanceSkincolor;
